import { useState, useEffect } from 'react';
import { DEFAULT_VALUE_MONTH } from '../_config/constant';

import type { IDateType, IDateValue } from '@/pages/intelligence/types/common';
import type { IPickerValue, IDateTypeOption } from '../types';

export default function useResult(props: {
  types: IDateTypeOption[];
  value?: IPickerValue;
  defaultValue?: IPickerValue;
  onConfirm?: (type: IDateType, value: IDateValue) => void;
  onCancel?: () => void;
}) {
  const { types, value, defaultValue, onConfirm, onCancel } = props;
  const initialValue = value ?? defaultValue ?? DEFAULT_VALUE_MONTH;
  // console.log('useResult', props);
  // console.log('initialValue', initialValue);
  const [result, setResult] = useState<IPickerValue>(initialValue);

  // 判断传入的 value 是否符合规则
  const isValidValue = (value = {} as any) => {
    const isValid =
      Array.isArray(value?.value) && types?.find((item) => item.value === value?.type);
    if (!isValid) {
      console.error('RangeDayMonethSelector 传入的 value 不符合规则');
    }
    return isValid;
  };

  const handleConfirm = (type: IDateType, value: IDateValue) => {
    // 不允许输入负数，-0 为 0
    const valueTemp = value?.map((item) => {
      const numItem = Math.abs(Number.parseInt(item, 10));
      return String(numItem);
    });
    onConfirm?.(type, valueTemp as IDateValue);
    setResult({
      type,
      value,
    });
  };

  const handleCancel = () => {
    onCancel?.();
  };

  useEffect(() => {
    if (!isValidValue(value)) return;
    setResult(value as IPickerValue);
  }, [value]);

  return {
    result,
    handleConfirm,
    handleCancel,
  };
}
